import { useMutation } from '@tanstack/react-query';
import { amendFunctionalScore } from '../services/fuctional_checklist';

const AmendFunctionalScore = () => {
    const amendFunctionalScoreMutation = useMutation({
        mutationFn: ({ entryId, data }) => amendFunctionalScore(entryId, data),
        onSuccess: (data) => {
        },
        onError: (error) => {
            console.error('Error amending functional score:', error);
        },
    });

    return amendFunctionalScoreMutation;
};

export default AmendFunctionalScore;
